import { useState, useEffect } from 'react';

/**
 *
 * @param Phone Object with code and characteristics
 * @param Phone.code Area code
 * @param Phone.characteristic Characteristics
 * @returns maxLength = {code, number, characteristic}
 */

export const usePhoneLength = (phone) => {
    const [maxLen, setMaxLen] = useState(phone);

    const parsePhone = (value) => {
        if (typeof value === 'string') return value;
        if (typeof value === 'number') return value.toString();
    };

    useEffect(() => {
        if (parsePhone(phone.code).length !== 0 && parsePhone(phone.characteristic).length !== 0) {
            return setMaxLen(prev => {
                return {
                    ...prev,
                    code: parsePhone(phone.code).length,
                    characteristic: parsePhone(phone.characteristic).length,
                    number: parsePhone(phone.number).length
                };
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return maxLen;
};
